import { first } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'simple-select',
    templateUrl: './simple-select.component.html',
    styleUrls: ['./simple-select.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SimpleSelectComponent implements OnInit {

    public _showOverlay: boolean = false;
    @Input() loading: boolean = false;
    @Input() hideLoading: boolean = false;
    @Input() showHorizontalRuler: boolean = true;

    @Input() set show(show: boolean) {
        if(show == this._showOverlay) return;
        this._showOverlay = show;
    }
    @Output() showChange = new EventEmitter<boolean>();

    @Input() selectedValues: Array<any> = [];
    @Input() okLabel: string = '';
    @Input() cancelLabel: string = '';
    @Input() hideOk: boolean = false;
    @Input() hideCancel: boolean = false;
    /** Icon name for OK button (as implemented in `SvgIconComponent`) */
    @Input() okIcon: string = null;
    /** Icon name for Cancel button (as implemented in `SvgIconComponent`) */
    @Input() cancelIcon: string = null;
    @Input() hideOnSelect: boolean = true;
    /** Flag to determine whether clicks outside the select dialog should have any effect. Default is `false` (i.e. clicks outside invoke the cancel flow) */
    @Input() forceSelect: boolean = false;
    /** Flag to determine whether to animate the popup. Default is `false` */
    @Input() animated: boolean = false;
    /** Flag to set transparent motes-card */
    @Input() transparent: boolean = false;

    @Output() selectionDone = new EventEmitter<any | null>();
    @Output() onOk = new EventEmitter<any>();
    @Output() onCancel = new EventEmitter<void>();

    public showSelect(): Promise<any> {
        this.show = true;
        return this.selectionDone.pipe(first()).toPromise();
    }

    constructor() { }

    ngOnInit() {
    }

    public cancel() {
        if(this.hideOnSelect) this.show = false;
        this.selectionDone.emit(null);
        this.onCancel.emit();
        this.showChange.emit(this.show);
    }

    public confirm() {
        if(this.hideOnSelect) this.show = false;
        this.selectionDone.emit(this.selectedValues);
        this.onOk.emit(this.selectedValues);
    }

    public overlayClick() {
        if(!this.forceSelect)
            this.cancel();
    }
}
